export const experiences = [
    {
        title: "Software Engineer",
        company: "Dynamic Build Systems",
        date: "July 2025 - Present",
        icon: "mdi:language-csharp",
        backgroundColor: "#404040",
        industry: "Manufacturing",
        tech: ["C# .NET", "SQL"],
    },
    {
        title: "Software Engineer",
        company: "Culture Systems",
        date: "Jul 2024 - Jun 2025",
        icon: "mdi:language-rust",
        backgroundColor: "#404040",
        industry: "Agri-Manufacturing",
        tech: ["Flutter", "Rust"],
    },
    {
        title: "Software Engineer",
        company: "Kaha",
        date: "Oct 2023 - June 2024",
        icon: "mdi:language-csharp",
        backgroundColor: "#404040",
        industry: "Fintech",
        tech: ["C# .NET", "React", "AWS"],
    },
    {
        title: "Jewellery Designer",
        company: "Self Employed",
        date: "Oct 2014 - 2023",
        icon: "mdi:diamond",
        backgroundColor: "#404040",
        industry: "Design",
        description:
            "Designed custom engagement rings and jewellery, working closely with customers to provide advice and support while maintaining a loyal customer base.",
    },
];
